import ColorPicker from 'lib/ui/ColorPicker'
import React from 'react'
import {Controller} from 'react-hook-form'
import {useConfig} from 'organization/Event/Configurable'
import CollapsibleSection from 'lib/ui/ConfigPanel/CollapsibleSection'
import Label from 'lib/ui/TextField/Label'
import FontSelect from 'lib/FontSelect'
import BackgroundPicker from 'lib/ui/form/BackgroundPicker'
import {CountdownTimerSectionProps} from 'Event/template/Townhall/Dashboard/Main/CountdownTimerSection'

export default function Styling(props: {
  countdownTimerSection: CountdownTimerSectionProps
  sectionId: string
}) {
  const {countdownTimerSection, sectionId} = props
  const {
    form: {control},
  } = useConfig()

  return (
    <>
      <CollapsibleSection
        label="Background"
        storageKey="dashboard.blogSection.styling"
      >
        <Controller
          name={`dashboardSections.${sectionId}.background`}
          control={control}
          defaultValue={countdownTimerSection.background}
          render={({onChange, value}) => (
            <BackgroundPicker
              hasFreeSize
              label="Background Color"
              background={value}
              onChange={onChange}
            />
          )}
        />
      </CollapsibleSection>
      <CollapsibleSection
        label="Typography"
        storageKey="dashboard.countdownTimerSection.text.styling"
      >
        <Label>Font</Label>
        <Controller
          control={control}
          name={`dashboardSections.${sectionId}.font`}
          defaultValue={countdownTimerSection.font || null}
          render={({value, onChange}) => (
            <FontSelect value={value} onChange={onChange} />
          )}
        />
        <Controller
          name={`dashboardSections.${sectionId}.color`}
          control={control}
          defaultValue={countdownTimerSection.color || ''}
          render={({value, onChange}) => (
            <ColorPicker
              label="Font Color"
              aria-label="font color"
              color={value}
              onPick={onChange}
            />
          )}
        />
      </CollapsibleSection>
    </>
  )
}
